// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmjs.org/css-loader/3.6.0_webpack@4.43.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "fieldset.svelte-1myiyqa.svelte-1myiyqa{grid-column:span 2}fieldset.svelte-1myiyqa legend.svelte-1myiyqa{font-weight:bold}", ""]);
// Exports
module.exports = exports;
